import React from 'react';

import { Badge } from '@buildoutinc/blueprint-react/ui/Badge';

import { STATUS_LABELS, type AcfrStatus } from './types';

interface Props {
  status: AcfrStatus;
}

export default function StatusBadge({ status }: Props) {
  const attention = status === 'needs_review' || status === 'failed' || status === 'extracted';

  return (
    <Badge appearance={attention ? 'accent' : 'muted'} variant={attention ? 'primary' : 'secondary'}>
      {STATUS_LABELS[status]}
    </Badge>
  );
}
